import router from '@/router'
import { getHashList } from '@/coreApi/coreApiHelper'
// eslint-disable-next-line no-unused-vars,import/no-extraneous-dependencies
const moment = require('moment')

const FILTER_QUERY_STRING_NAME = 'af'
const FILTER_QUERY_STRING_DETAILS_NAME = 'dtls'

export const FILTER_TYPES = {
    VALUES: 'VALUES',
    DATE_INDICATOR: 'DATE_INDICATOR',
    WEEK_INDICATOR: 'WEEK_INDICATOR',
    MONTH_INDICATOR: 'MONTH_INDICATOR',
    DATE_MULTI_INDICATOR: 'DATE_MULTI_INDICATOR',
}

export class CoreApiFilterObject {
    id = ''

    type = ''

    filterList = [];

    constructor(id, type, filterList) {
        this.id = id
        this.type = type
        this.filterList = filterList
    }

    getFilterList() {
        const list = []
        this.filterList.forEach(filterItem => {
            const filterListItem = {
                title: filterItem.title,
                key: filterItem.key,
                filter_type: filterItem.filter_type,
                field_name: filterItem.field_name,
                data: [],
            }
            filterItem.data.forEach(dataItem => {
                if (typeof dataItem === 'string') {
                    filterListItem.data.push(dataItem)
                } else {
                    filterListItem.data.push({
                        l: dataItem.label,
                        v: `${filterItem.key}:${dataItem.value}`,
                    })
                }
            })
            list.push(filterListItem)
        })
        return list
    }

    getQueryStringFilter() {
        const currentHashList = getHashList()
        let filter = null
        let currentFilterList = null

        if (FILTER_QUERY_STRING_NAME in currentHashList) {
            currentFilterList = JSON.parse(currentHashList[FILTER_QUERY_STRING_NAME])
        }

        if (currentFilterList && this.id in currentFilterList) {
            filter = currentFilterList[this.id]
        }

        return filter
    }

    getFilterUrl(filters) {
        const currentHashList = getHashList()
        let currentFilterList = {}

        if (FILTER_QUERY_STRING_NAME in currentHashList) {
            currentFilterList = JSON.parse(currentHashList[FILTER_QUERY_STRING_NAME])
        }

        let multipleSelectExist = false
        if (typeof filters.multipleSelect !== 'undefined') {
            // eslint-disable-next-line no-restricted-syntax
            for (const [, multipleSelectValues] of Object.entries(filters.multipleSelect)) {
                if (multipleSelectValues.length) {
                    multipleSelectExist = true
                }
            }
        }

        let searchAutosuggestExist = false
        if (typeof filters.searchAutosuggest !== 'undefined') {
            // eslint-disable-next-line no-restricted-syntax
            for (const [, searchAutosuggestValues] of Object.entries(filters.searchAutosuggest)) {
                if (searchAutosuggestValues.length) {
                    searchAutosuggestExist = true
                }
            }
        }

        if (
            (typeof filters.checkbox !== 'undefined' && filters.checkbox.length)
          || (typeof filters.datetime !== 'undefined' && filters.datetime.length)
          || (typeof filters.datetimeRange !== 'undefined' && filters.datetimeRange.length)
          || (typeof filters.week !== 'undefined' && filters.week.length)
          || (typeof filters.month !== 'undefined' && filters.month.length)
          || multipleSelectExist
          || searchAutosuggestExist
        ) {
            currentFilterList[this.id] = filters
        } else if (this.id in currentFilterList) {
            delete currentFilterList[this.id]
        }

        if (Object.keys(currentFilterList).length > 0) {
            currentHashList[FILTER_QUERY_STRING_NAME] = JSON.stringify(currentFilterList)
        } else if (FILTER_QUERY_STRING_NAME in currentHashList) {
            delete currentHashList[FILTER_QUERY_STRING_NAME]
        }

        if (typeof filters.details !== 'undefined') {
            if (filters.details) {
                currentHashList[FILTER_QUERY_STRING_DETAILS_NAME] = JSON.stringify(filters.details)
            } else {
                delete currentHashList[FILTER_QUERY_STRING_DETAILS_NAME]
            }
        }

        let url = router.currentRoute.path
        if (Object.keys(currentHashList).length > 0) {
            const query = Object.entries(currentHashList)
                .map(pair => pair.map(encodeURIComponent).join('='))
                .join('&')

            url += `#${query}`
        }

        return url
    }

    getFilterQueryObject() {
        let queryObject = null
        switch (this.type) {
        case FILTER_TYPES.VALUES:
            queryObject = this.getFilterQueryObjectValues()
            break
        case FILTER_TYPES.DATE_INDICATOR:
            queryObject = this.getFilterQueryObjectDateIndicator()
            break
        case FILTER_TYPES.DATE_MULTI_INDICATOR:
            queryObject = this.getFilterQueryObjectDateRangeIndicator()
            break
        case FILTER_TYPES.WEEK_INDICATOR:
            queryObject = this.getFilterQueryObjectWeekIndicator()
            break
        case FILTER_TYPES.MONTH_INDICATOR:
            queryObject = this.getFilterQueryObjectMonthIndicator()
            break
        default:
            queryObject = null
        }
        return queryObject
    }

    getFilterQueryObjectDate() {
        let object = null
        switch (this.type) {
        case FILTER_TYPES.DATE_INDICATOR:
            object = this.getFilterQueryObjectDateDate()
            break
        case FILTER_TYPES.DATE_MULTI_INDICATOR:
            object = this.getFilterQueryObjectDateRangeDate()
            break
        case FILTER_TYPES.WEEK_INDICATOR:
            object = this.getFilterQueryObjectWeekDate()
            break
        case FILTER_TYPES.MONTH_INDICATOR:
            object = this.getFilterQueryObjectMonthDate()
            break
        default:
            object = null
        }
        return object
    }

    // eslint-disable-next-line class-methods-use-this
    getFilterDetails() {
        let detailsObject = null
        const currentHashList = getHashList()
        if (FILTER_QUERY_STRING_DETAILS_NAME in currentHashList) {
            detailsObject = JSON.parse(currentHashList[FILTER_QUERY_STRING_DETAILS_NAME])
        }
        return detailsObject
    }

    getFilterQueryObjectValues() {
        const queryStringFilter = this.getQueryStringFilter()
        const queryFilterObject = {}
        if (queryStringFilter) {
            if (queryStringFilter.checkbox) {
                queryStringFilter.checkbox.forEach(item => {
                    const itemSplit = item.split(':')
                    if (itemSplit.length === 2) {
                        const key = itemSplit[0]
                        const value = itemSplit[1]
                        if (!(key in queryFilterObject)) {
                            queryFilterObject[key] = []
                        }
                        queryFilterObject[key].push(value)
                    }
                })
            }

            if (queryStringFilter.multipleSelect) {
                // eslint-disable-next-line no-restricted-syntax
                for (const [multipleSelectKey, multipleSelectElements] of Object.entries(queryStringFilter.multipleSelect)) {
                    multipleSelectElements.forEach(item => {
                        const itemSplit = item.v.split(':')
                        if (itemSplit.length === 2) {
                            const key = itemSplit[0]
                            const value = itemSplit[1]
                            if (!(key in queryFilterObject)) {
                                queryFilterObject[multipleSelectKey] = []
                            }
                            queryFilterObject[multipleSelectKey].push(value)
                        }
                    })
                }
            }

            if (queryStringFilter.searchAutosuggest) {
                // eslint-disable-next-line no-restricted-syntax
                for (const [searchAutosuggestKey, searchAutosuggestElements] of Object.entries(queryStringFilter.searchAutosuggest)) {
                    if (searchAutosuggestElements) {
                        queryFilterObject[searchAutosuggestKey] = searchAutosuggestElements
                    }
                }
            }
        }
        const queryObject = []
        if (Object.keys(queryFilterObject).length) {
            // eslint-disable-next-line no-restricted-syntax
            for (const [queryFilterKey, queryFilterValues] of Object.entries(queryFilterObject)) {
                const filterItem = this.filterList.filter(obj => obj.key === queryFilterKey)[0]
                if (filterItem) {
                    let value = ''
                    if (typeof queryFilterValues === 'string') {
                        value = queryFilterValues
                        if (filterItem.filter_value_lowercase) {
                            value = value.toLowerCase()
                        }
                    } else {
                        value = queryFilterValues.join(',')
                    }

                    queryObject.push({
                        key: filterItem.field_name,
                        value,
                    })
                }
            }
        }

        return queryObject
    }

    getFilterQueryObjectDateIndicator() {
        const queryStringFilter = this.getQueryStringFilter()
        const queryFilterObject = {}
        if (queryStringFilter && typeof queryStringFilter.datetime !== 'undefined' && queryStringFilter.datetime.length) {
            queryStringFilter.datetime.forEach(item => {
                const itemSplit = item.split(':')
                if (itemSplit.length === 2) {
                    const key = itemSplit[0]
                    const value = itemSplit[1]
                    if (!(key in queryFilterObject)) {
                        queryFilterObject[key] = []
                    }
                    queryFilterObject[key].push(value)
                }
            })
        }
        let queryObject = { type: 'daily', skip: 0, take: 1 }
        if (Object.keys(queryFilterObject).length) {
            // eslint-disable-next-line no-restricted-syntax
            for (const [queryFilterKey, queryFilterValues] of Object.entries(queryFilterObject)) {
                const filterItem = this.filterList.filter(obj => obj.key === queryFilterKey)[0]
                if (filterItem) {
                    const filterData = {
                        key: filterItem.field_name,
                        value: queryFilterValues.join(','),
                    }
                    const today = moment()
                    const selectedDate = moment(filterData.value, 'YYYY-MM-DD', true)
                    const type = 'daily'
                    const skip = today.diff(selectedDate, 'days')
                    const take = 1
                    queryObject = { type, skip, take }
                }
            }
        }

        return queryObject
    }

    getFilterQueryObjectDateDate() {
        const queryStringFilter = this.getQueryStringFilter()
        const queryFilterObject = {}
        if (queryStringFilter && typeof queryStringFilter.datetime !== 'undefined' && queryStringFilter.datetime.length) {
            queryStringFilter.datetime.forEach(item => {
                const itemSplit = item.split(':')
                if (itemSplit.length === 2) {
                    const key = itemSplit[0]
                    const value = itemSplit[1]
                    if (!(key in queryFilterObject)) {
                        queryFilterObject[key] = []
                    }
                    queryFilterObject[key].push(value)
                }
            })
        }
        let date = moment().format('YYYY-MM-DD')
        if (Object.keys(queryFilterObject).length) {
            // eslint-disable-next-line no-restricted-syntax
            for (const [queryFilterKey, queryFilterValues] of Object.entries(queryFilterObject)) {
                const filterItem = this.filterList.filter(obj => obj.key === queryFilterKey)[0]
                if (filterItem) {
                    const filterData = {
                        key: filterItem.field_name,
                        value: queryFilterValues.join(','),
                    }
                    date = moment(filterData.value, 'YYYY-MM-DD', true)
                }
            }
        }

        return date
    }

    getFilterQueryObjectDateRangeIndicator() {
        const queryStringFilter = this.getQueryStringFilter()
        const queryFilterObject = {}

        if (queryStringFilter && typeof queryStringFilter.datetimeRange !== 'undefined' && queryStringFilter.datetimeRange.length) {
            queryStringFilter.datetimeRange.forEach(item => {
                const itemSplit = item.split(':', 1)
                if (itemSplit.length === 1) {
                    const dateRange = item.replace(`${itemSplit}:`, '')

                    if (dateRange) {
                        const key = itemSplit[0]
                        if (!(key in queryFilterObject)) {
                            queryFilterObject[key] = []
                        }
                        queryFilterObject[key].push(dateRange)
                    }
                }
            })
        }

        let queryObject = { type: 'daily', skip: 0, take: 1 }
        if (Object.keys(queryFilterObject).length) {
            // eslint-disable-next-line no-restricted-syntax
            for (const [queryFilterKey, queryFilterValues] of Object.entries(queryFilterObject)) {
                const filterItem = this.filterList.filter(obj => obj.key === queryFilterKey)[0]
                if (filterItem) {
                    let dateRange = null
                    try {
                        dateRange = JSON.parse(queryFilterValues)
                    } catch (e) {
                        dateRange = null
                    }
                    if (dateRange
                      && dateRange.startDate
                      && dateRange.endDate
                    ) {
                        const startDate = moment(dateRange.startDate, 'YYYY-MM-DD', true)
                        const endDate = moment(dateRange.endDate, 'YYYY-MM-DD', true)
                        const today = moment()
                        const type = 'daily'
                        const skip = today.diff(startDate, 'days')
                        const take = endDate.diff(startDate, 'days') + 1
                        queryObject = { type, skip, take }
                    }
                }
            }
        }

        return queryObject
    }

    getFilterQueryObjectDateRangeDate() {
        const queryStringFilter = this.getQueryStringFilter()
        const queryFilterObject = {}

        if (queryStringFilter && typeof queryStringFilter.datetimeRange !== 'undefined' && queryStringFilter.datetimeRange.length) {
            queryStringFilter.datetimeRange.forEach(item => {
                const itemSplit = item.split(':', 1)
                if (itemSplit.length === 1) {
                    const dateRange = item.replace(`${itemSplit}:`, '')

                    if (dateRange) {
                        const key = itemSplit[0]
                        if (!(key in queryFilterObject)) {
                            queryFilterObject[key] = []
                        }
                        queryFilterObject[key].push(dateRange)
                    }
                }
            })
        }

        let queryObject = { star_date: moment().format('YYYY-MM-DD'), end_date: moment().format('YYYY-MM-DD') }
        if (Object.keys(queryFilterObject).length) {
            // eslint-disable-next-line no-restricted-syntax
            for (const [queryFilterKey, queryFilterValues] of Object.entries(queryFilterObject)) {
                const filterItem = this.filterList.filter(obj => obj.key === queryFilterKey)[0]
                if (filterItem) {
                    let dateRange = null
                    try {
                        dateRange = JSON.parse(queryFilterValues)
                    } catch (e) {
                        dateRange = null
                    }
                    if (dateRange
                      && dateRange.startDate
                      && dateRange.endDate
                    ) {
                        const startDate = moment(dateRange.startDate, 'YYYY-MM-DD', true)
                        const endDate = moment(dateRange.endDate, 'YYYY-MM-DD', true)

                        queryObject = { star_date: startDate, end_date: endDate }
                    }
                }
            }
        }

        return queryObject
    }

    getFilterQueryObjectWeekIndicator() {
        const queryStringFilter = this.getQueryStringFilter()
        const queryFilterObject = {}

        if (queryStringFilter && typeof queryStringFilter.week !== 'undefined' && queryStringFilter.week.length) {
            queryStringFilter.week.forEach(item => {
                const itemSplit = item.split(':', 1)
                if (itemSplit.length === 1) {
                    const week = item.replace(`${itemSplit}:`, '')

                    if (week) {
                        const key = itemSplit[0]
                        if (!(key in queryFilterObject)) {
                            queryFilterObject[key] = []
                        }
                        queryFilterObject[key].push(week)
                    }
                }
            })
        }

        let queryObject = { type: 'weekly', skip: 0, take: 1 }
        if (Object.keys(queryFilterObject).length) {
            // eslint-disable-next-line no-restricted-syntax
            for (const [queryFilterKey, queryFilterValues] of Object.entries(queryFilterObject)) {
                const filterItem = this.filterList.filter(obj => obj.key === queryFilterKey)[0]
                if (filterItem) {
                    let week = null
                    try {
                        week = queryFilterValues
                    } catch (e) {
                        week = null
                    }

                    if (week) {
                        const weekDate = moment(week, 'YYYY-MM-DD', true)
                        const today = moment()
                        const type = 'weekly'
                        const skip = today.diff(weekDate, 'weeks')
                        const take = 1
                        queryObject = { type, skip, take }
                    }
                }
            }
        }

        return queryObject
    }

    getFilterQueryObjectWeekDate() {
        const queryStringFilter = this.getQueryStringFilter()
        const queryFilterObject = {}

        if (queryStringFilter && typeof queryStringFilter.week !== 'undefined' && queryStringFilter.week.length) {
            queryStringFilter.week.forEach(item => {
                const itemSplit = item.split(':', 1)
                if (itemSplit.length === 1) {
                    const week = item.replace(`${itemSplit}:`, '')

                    if (week) {
                        const key = itemSplit[0]
                        if (!(key in queryFilterObject)) {
                            queryFilterObject[key] = []
                        }
                        queryFilterObject[key].push(week)
                    }
                }
            })
        }

        let date = null
        if (Object.keys(queryFilterObject).length) {
            // eslint-disable-next-line no-restricted-syntax
            for (const [queryFilterKey, queryFilterValues] of Object.entries(queryFilterObject)) {
                const filterItem = this.filterList.filter(obj => obj.key === queryFilterKey)[0]
                if (filterItem) {
                    date = null
                    try {
                        date = queryFilterValues
                        if (Array.isArray(date)) {
                            // eslint-disable-next-line prefer-destructuring
                            date = date[0]
                        }
                    } catch (e) {
                        date = null
                    }
                }
            }
        }

        if (!date) {
            date = moment().startOf('week').add(1, 'days').format('YYYY-MM-DD')
        }

        return date
    }

    getFilterQueryObjectMonthIndicator() {
        const queryStringFilter = this.getQueryStringFilter()
        const queryFilterObject = {}

        if (queryStringFilter && typeof queryStringFilter.month !== 'undefined' && queryStringFilter.month.length) {
            queryStringFilter.month.forEach(item => {
                const itemSplit = item.split(':', 1)
                if (itemSplit.length === 1) {
                    const month = item.replace(`${itemSplit}:`, '')

                    if (month) {
                        const key = itemSplit[0]
                        if (!(key in queryFilterObject)) {
                            queryFilterObject[key] = []
                        }
                        queryFilterObject[key].push(month)
                    }
                }
            })
        }

        let queryObject = { type: 'monthly', skip: 0, take: 1 }
        if (Object.keys(queryFilterObject).length) {
            // eslint-disable-next-line no-restricted-syntax
            for (const [queryFilterKey, queryFilterValues] of Object.entries(queryFilterObject)) {
                const filterItem = this.filterList.filter(obj => obj.key === queryFilterKey)[0]
                if (filterItem) {
                    let month = null
                    try {
                        month = queryFilterValues
                    } catch (e) {
                        month = null
                    }

                    if (month) {
                        const monthDate = moment(month, 'YYYY-MM-DD', true)
                        const today = moment()
                        const type = 'monthly'
                        const skip = today.diff(monthDate, 'months')
                        const take = 1
                        queryObject = { type, skip, take }
                    }
                }
            }
        }

        return queryObject
    }

    getFilterQueryObjectMonthDate() {
        const queryStringFilter = this.getQueryStringFilter()
        const queryFilterObject = {}

        if (queryStringFilter && typeof queryStringFilter.month !== 'undefined' && queryStringFilter.month.length) {
            queryStringFilter.month.forEach(item => {
                const itemSplit = item.split(':', 1)
                if (itemSplit.length === 1) {
                    const month = item.replace(`${itemSplit}:`, '')

                    if (month) {
                        const key = itemSplit[0]
                        if (!(key in queryFilterObject)) {
                            queryFilterObject[key] = []
                        }
                        queryFilterObject[key].push(month)
                    }
                }
            })
        }

        let date = null
        if (Object.keys(queryFilterObject).length) {
            // eslint-disable-next-line no-restricted-syntax
            for (const [queryFilterKey, queryFilterValues] of Object.entries(queryFilterObject)) {
                const filterItem = this.filterList.filter(obj => obj.key === queryFilterKey)[0]
                if (filterItem) {
                    let month = null
                    try {
                        month = queryFilterValues
                    } catch (e) {
                        month = null
                    }

                    if (month) {
                        date = moment(month, 'YYYY-MM-DD', true).format('YYYY-MM-DD')
                    }
                }
            }
        }

        if (!date) {
            date = moment().startOf('month').format('YYYY-MM-DD')
        }

        return date
    }
}
